import { SET_REPORT_NUMBER as type } from '.';

export default payload => ({
  type,
  payload,
});
